export default "__VITE_ASSET__CIdW2YdE__"